import { useLocation, useParams } from 'wouter'
import { ArrowLeft02Icon } from '@hugeicons/core-solid-rounded'

import { ClaimOrganizationForm } from '@/features/organization'
import { useAuth } from '@/features/auth'
import { HugeiconsIcon } from '@hugeicons/react'
import { CurrentUserButton } from '@/features/user'

export default function ClaimOrganization() {
  const { session } = useAuth()
  const [, navigate] = useLocation()

  const { secret, slug } = useParams() as { secret: string; slug: string }

  return (
    <div className="w-screen h-screen mesh-bg-primary p-4 overflow-y-auto">
      <div className="flex flex-col justify-center min-h-full">
        <div className="flex flex-col bg-white rounded max-w-[600px] w-full p-6 gap-2.5 mx-auto">
          <div className="flex flex-row justify-start gap-2.5">
            {!!session?.currentOrgId && (
              <button tabIndex={0} onClick={() => navigate('/goodies')}>
                <HugeiconsIcon
                  icon={ArrowLeft02Icon}
                  className="size-6 text-text"
                />
              </button>
            )}
            <CurrentUserButton type="row" />
          </div>
          <ClaimOrganizationForm secret={secret} slug={slug} />
        </div>
      </div>
    </div>
  )
}
